<template>
    <div class="flex flex-wrap w-full h-full justify-center items-center">
        <div class="flex flex-wrap flex-col max-w-xl m-auto rounded-md w-10/12 md:w-6/12 xl:w-3/12 2xl:w-3/12">
            <div class="rounded-3xl w-full bg-white dark:bg-stone-900"
            :class="[authError != null ? 'shake' : '']">
                <!-- <img src="https://t3.ftcdn.net/jpg/04/68/17/58/360_F_468175854_cEU6WqxN6Q504R3L7CkDI38Jkh7tYVH4.jpg" class="rounded-3xl w-full"/> -->
                <div class="w-full flex flex-row items-center justify-center rounded-t-3xl" style="background-color: #ffcd09">
                    <img :src="require('@/assets/logo.png')" class="h-32"/>
                </div>
                <!-- <div class="pt-4 pb-4 text-gray-800 text-center"><h1>Добро пожаловать</h1></div> -->
                <div class="pb-4 pt-8 px-8">
                    <div class="p-2">
                        <text-input
                            v-model="user.phone"
                            iconUrl="https://img.icons8.com/ios-glyphs/256/user.png"
                            placeholder="Номер телефона"
                            type="phone"
                            validate="phone"
                            required
                            ref="loginInput"
                            />
                    </div>
                    <div class="p-2">
                        <text-input
                            v-model="user.password"
                            iconUrl="https://img.icons8.com/ios-filled/256/lock-2.png"
                            placeholder="Пароль"
                            type="password"
                            validate="min:4|max:25"
                            ref="passwordInput"
                            />
                    </div>
                </div>
                <div class="pb-4 w-full flex-col justify-center items-center select-none px-8">
                    <div class="w-full flex items-center">
                        <div class="w-2/3 py-2">
                            <router-link :to="{ name: 'Register' }">
                                <div class="text-md text-center cursor-pointer hover:font-semibold hover:text-lime-700 hover:bg-lime-100 py-3 rounded-full">{{ loc('register_btn') }}</div>
                            </router-link>
                        </div>
                        <div v-if="!isLogginIn" class="w-full flex flex-col justify-center items-center">
                            <button @click.prevent="loginUser" type="submit" class="w-11/12 font-semibold text-center text-white bg-lime-500 border-0 py-3 px-8 focus:outline-none hover:bg-lime-700 active:bg-lime-900 rounded-full">{{ loc('login_btn') }}</button>
                        </div>
                        <div v-else class="w-full h-12 flex justify-center items-center bg-white rounded-md">
                            <img src="https://static.breaktime.kz/uploads/images/breaktime/loading_black_circle.gif" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-center pb-32 px-4">
                <div class="p-4 w-full text-rose-500 text-center bg-red-100 rounded-br-md rounded-bl-md" v-if="authError">
                    {{ authError }}
                </div>
                <div v-else class="p-4">&nbsp;</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {
            user: {
                phone: '',
                password: ''
            },
            isLogginIn: false,
            authError: null
        }
    },
    computed: {
        isLoginValid () {
            return this.$refs.loginInput.isValid
            // if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/.test(this.user.email)) return true
            // else return false
        },
        isPasswordValid () {
            return this.$refs.passwordInput.isValid
            // if (this.user.password.length > 0) return true
            // else return false
        }
    },
    methods: {
        loginUser () {
            this.authError = null
            this.isLogginIn = true
            if (!this.isLoginValid) {
                this.$refs.loginInput.$refs.input.focus()
                this.isLogginIn = false
                this.authError = this.$refs.loginInput.validationErrors
            } else
            if (!this.isPasswordValid) {
                this.$refs.passwordInput.$refs.input.focus()
                this.isLogginIn = false
                this.authError = this.$refs.passwordInput.validationErrors
            } else
            if (this.isLoginValid && this.isPasswordValid) {
                this.$store
                    .dispatch('loginUser', this.user)
                    .then()
                    .catch((error) => { this.authError = error })
                    .finally(() => setTimeout(() => { this.isLogginIn = false }, 300))
            }
        }
    }
}
</script>
<style>
    html, body, #app {
        height: 100% !important;
    }
    .main_wrapper{
        background-image: url("https://breaktime.kz/_css/images/body_bg_1_1.png");
        background-size: cover;
        background-position: center;
        background-color: #ff7d7d;
        /* filter: blur(8px);
        -webkit-filter: blur(8px); */
    }
    .shake {
        /* animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both; */
        animation: shake 0.62s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
        transform: translate3d(0, 0, 0);
    }

    @keyframes shake {
        10%,
        90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%,
        80% {
            transform: translate3d(2px, 0, 0);
        }

        30%,
        50%,
        70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%,
        60% {
            transform: translate3d(4px, 0, 0);
        }
    }
</style>